import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    if (!localStorage.getItem("age_verified")) {
      this.modalTarget.classList.add("age-gate--open")
      document.body.style.overflow = "hidden"
    }
  }

  confirm() {
    localStorage.setItem("age_verified", "true")
    this.modalTarget.classList.remove("age-gate--open")
    document.body.style.overflow = ""
  }

  deny() {
    window.location.href = "https://google.com"
  }
}
